var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "itemLogsLineChart-lineChart-container",
    staticStyle: {
      with: "100%",
      height: "100%"
    }
  }, [!_vm.data.length ? _c("div", {
    staticClass: "block"
  }, [_vm._v("暂无水质数据")]) : _c("div", {
    staticStyle: {
      with: "100%",
      height: "100%"
    },
    attrs: {
      id: _vm.id
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };